import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getJob, deleteJob } from "../../slice/workerJobSlice";
import "./style/workerListing-style.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getShiftJobs, deleteShiftJob } from "../../slice/workerShiftAddJobSlice";

import Pagination from "../../../../../pagination/components";

const WorkerShiftJobList = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const { shiftJobData, loading, error, pagination } = useSelector(
        (state) => state.workerShiftJob
    );
    const token = localStorage.getItem("token");

    useEffect(() => {
        if (!token) return;

        dispatch(getShiftJobs({ token, page }));
    }, [token, dispatch, page]);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.last_page) {
            setPage(newPage);
        }
    };

    console.log("shiftJobData", shiftJobData);

    const handleDelete = async (jobId) => {
        const confirmed = window.confirm("Are you sure you want to delete this job?");
        if (!confirmed) return;

        const result = await dispatch(deleteShiftJob({ token, id: jobId }));

        if (result.meta.requestStatus === "fulfilled") {
            toast.success("Shift Job deleted successfully", {
                position: "top-right",
                autoClose: 2000,
                style: { fontSize: "0.85rem" },
            });
            dispatch(getShiftJobs({ token, page })); // Refresh list
        } else {
            toast.error("Failed to delete job", {
                position: "top-right",
                autoClose: 2000,
                style: { fontSize: "0.85rem" },
            });
        }
    };

      const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "accepted":
        return "bg-success";
      case "offerssent":
        return "bg-warning text-dark";
      default:
        return "bg-secondary";
    }
  };

    return (
        <>
            <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
                <div className="ps-2 ps-lg-4">
                    <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
                        Shift Request
                    </h4>

                    {/* LOADING */}
                    {loading && <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>}

                    {/* ERROR */}
                    {error && <p className="text-danger">{error}</p>}
                    {!loading && !error && (
                        <main className="overflow-hidden">
                            <section className="pb-5">
                                <div className="container">
                                    <div className="form-section bg-light rounded p-3 p-sm-4">
                                        {shiftJobData.length === 0 ? (
                                            <div className="text-center py-5">
                                                <h5 className="text-muted">No jobs available</h5>
                                            </div>
                                        ) : (
                                            shiftJobData.map((job) => {
                                                return (
                                                    <div
                                                        className="row"
                                                        style={{ cursor: "pointer" }}
                                                        key={job.id}
                                                    // onClick={() => window.open(`/panel/shift-job-details/${job.id}`, '_blank')}
                                                    >
                                                        <div className="col-12">
                                                            <div className="card activity-card d-md-flex flex-md-row p-4 position-relative">

                                                                {/* 🔹 JOB TYPE (Top Right) */}
                                                                <div
                                                                    className="d-flex align-items-center gap-2 position-absolute"
                                                                    style={{ top: "15px", right: "15px", zIndex: 2 }}
                                                                >

                                                                    {/* EDIT */}
                                                                    <button
                                                                        className="btn btn-light-header"
                                                                        title="Edit Job"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            navigate(`/panel/edit-shift-job/${job.id}`)
                                                                        }}
                                                                    >
                                                                        <i className="fa fa-pencil text-light" />
                                                                    </button>

                                                                    {/* DELETE */}
                                                                    <button
                                                                        className="btn btn-light-header"
                                                                        title="Delete Job"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation(); // ❌ Prevent row click
                                                                            handleDelete(job.id);
                                                                        }}
                                                                    >
                                                                        <i className="fa fa-trash text-light" />
                                                                    </button>
                                                                </div>

                                                                <div
                                                                    className="position-relative services-list-box"
                                                                    style={{
                                                                        backgroundSize: "cover",
                                                                        backgroundPosition: "center",
                                                                        width: "25%",
                                                                    }}
                                                                >
                                                                    <a href="#" className="text-decoration-none position-absolute top-0 end-0 m-2">
                                                                        <i className="fa fa-heart-o text-white font-size-22" />
                                                                    </a>
                                                                </div>

                                                                <div className="card-body py-0 pe-0 ps-0 ps-md-4 ms-xl-1 mt-4 mt-md-0">

                                                                    <h6 className="font-weight-bold text-primary font-size-22 mb-2 montserrat">
                                                                        {job.title}
                                                                    </h6>

                                                                    <div className="text-muted font-size-14 mb-2">
                                                                        <strong>Min Salary:</strong> {job.salary_min}{" "}
                                                                        <strong>Max Salary:</strong> {job.salary_max}
                                                                    </div>

                                                                    <div className="text-muted font-size-14 mb-2">
                                                                        <strong>Start Date:</strong> {job.start_date}{" "}
                                                                        <strong>End Date:</strong> {job.end_date}
                                                                    </div>

                                                                    <div className="text-muted font-size-14 mb-2">
                                                                        <strong>Start Time:</strong> {job.start_time}{" "}
                                                                        <strong>End Time:</strong> {job.end_time}
                                                                    </div>

                                                                    

                                                                    <div className="text-muted font-size-14 mb-2">
                                                                        <strong>Location:</strong> {job.city}, {job.state}, {job.country}
                                                                    </div>

                                                                    <div className={`badge ${getStatusClass(job.status)} px-3 py-2 font-size-14`}>
                                                                        <strong>Status:</strong> {job.status}
                                                                    </div>

                                                                    <p className="mt-3" dangerouslySetInnerHTML={{ __html: job.description }} />

                                                                    <div className="d-flex justify-content-between align-items-center mt-4">
                                                                        <span
                                                                            className="rating-badge btn-light-header font-size-16 rounded-pill text-white px-3 py-2"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                navigate(`/panel/shift-job-details/${job.id}`)
                                                                            }}
                                                                        >
                                                                            View Details
                                                                        </span>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        )}
                                    </div>
                                </div>
                            </section>
                            <Pagination
                                currentPage={page}
                                totalPages={pagination.last_page || 0}
                                onPageChange={handlePageChange}
                            />
                        </main>
                    )}
                </div>
            </div>
        </>
    );
};

export default WorkerShiftJobList;